import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import style from './Header.css';
import Link from '../Link';
import Navigation from '../Navigation';
import logoUrl from '../../../public/logo/logo.jpg';

class Header extends React.Component {
  render() {
    return (
      <nav className={cx('navbar', 'navbar-default', style.navBarCustom, style.root)}>
        <div className={cx('container-fluid', style.container)}>
          <div className={cx('navbar-header', style.header)}>
            <Link className={style.brand} to="/home">
              <img src={logoUrl} className={style.logo} alt="Parkland Players" />
            </Link>
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar">
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          <div className={cx('collapse', 'navbar-collapse', style.collapse)} id="navbar">
            <Navigation />
          </div>
        </div>
      </nav>
    );
  }
}

export default withStyles(style)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js